module.exports = __webpack_public_path__ + "img/Pelletsheizung.f7b058a.png";